import {createListFromObject} from "../../Utilities/Types/listUtilities";

export const SYSTEM_TYPES = {
    LoanLibrary: 1,
    Own: 2,
};

export const SYSTEM_TYPES_LIST = createListFromObject(SYSTEM_TYPES);
